'use client';
import React from 'react';
import { Star, Eye, CalendarCheck, TrendingUp } from 'lucide-react';

const kpis = [
  {
    id: 'kpi-rating',
    label: 'Avg review rating',
    value: '4.9',
    sub: '23 reviews',
    icon: <Star size={20} style={{ color: 'var(--amber)' }} />,
    bg: 'var(--warning-bg)',
    trend: '+0.1 this month',
    trendUp: true,
  },
  {
    id: 'kpi-views',
    label: 'Profile views',
    value: '312',
    sub: 'Last 30 days',
    icon: <Eye size={20} style={{ color: 'var(--navy)' }} />,
    bg: '#EEF2FF',
    trend: '+48 vs last month',
    trendUp: true,
  },
  {
    id: 'kpi-bookings',
    label: 'Upcoming bookings',
    value: '3',
    sub: 'Next 7 days',
    icon: <CalendarCheck size={20} style={{ color: 'var(--success)' }} />,
    bg: 'var(--success-bg)',
    trend: '1 awaiting confirm',
    trendUp: true,
  },
  {
    id: 'kpi-response',
    label: 'Response rate',
    value: '97%',
    sub: 'Last 90 days',
    icon: <TrendingUp size={20} style={{ color: 'var(--primary)' }} />,
    bg: 'var(--orange-pale)',
    trend: 'Excellent',
    trendUp: true,
  },
];

export default function WorkerKPICards() {
  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-4">
      {kpis?.map((kpi) => (
        <div key={kpi?.id} className="card p-5" style={{ background: kpi?.bg }}>
          <div className="flex items-start justify-between mb-3">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-white/70">
              {kpi?.icon}
            </div>
          </div>
          <div className="tabular-nums text-2xl font-extrabold mb-0.5" style={{ color: 'var(--navy)' }}>{kpi?.value}</div>
          <div className="text-xs font-semibold mb-1" style={{ color: 'var(--muted-foreground)' }}>{kpi?.label}</div>
          <div className="text-xs" style={{ color: 'var(--muted-foreground)' }}>{kpi?.sub}</div>
          <div className="mt-2 text-xs font-semibold" style={{ color: kpi?.trendUp ? 'var(--success)' : 'var(--danger)' }}>
            {kpi?.trend}
          </div>
        </div>
      ))}
    </div>
  );
}